import environment from "web/script/modules/environment";

export function isActiveBlock(flag): boolean {
    const activeWebToAppBlocks = environment.get("activeWebToAppBlocks") || [];
    return activeWebToAppBlocks.includes(flag);
}

export function isActiveBanner(flag): boolean {
    const activeWebToAppBanners = environment.get("activeWebToAppBanners") || [];
    return activeWebToAppBanners.includes(flag);
}
